var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"log"},[_c('div',{staticClass:"log-type",class:_vm.log.type}),_c('div',{staticClass:"log-date"},[_vm._v(_vm._s(_vm.dateFormat(_vm.log.date)))]),_c('div',{staticClass:"log-category"},[_vm._v(_vm._s(_vm.log.category))]),_c('div',{staticClass:"log-message"},[_vm._v(_vm._s(_vm.log.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }